import React from 'react';
import './goodsHeader.css';
import { useDispatch } from "react-redux";
import { goodsFormAction, groupFormAction } from "../../../redux/rootReducer";
import { GOODS_FORM_INITIAL, GROUP_FORM_INITIAL } from "../../../redux/initialStateConstant";
import Toggle from "../../Toggle/Toggle";
import { exportGoodsRestToExcelSagaAction } from "../../../redux/sagaActions";

const GoodsHeader = ({ page, setPage, groups_page, setGroupsPage }) => {
    const dispatch = useDispatch();

    return (
        <>
            <Toggle active={ page } setHandler={ setPage } captionLeft={ 'Товары' } captionRight={ 'Настройки' }/>
            {
                !page
                &&
                <div
                    className={ `goods__groups ${ groups_page && 'goods__groups--active' }`}
                    onClick={ () => setGroupsPage(!groups_page) }
                >Настройка групп</div>
            }
            {
                !page && !groups_page
                &&
                <div className="button button--add"
                     onClick={ () => dispatch(goodsFormAction({ ...GOODS_FORM_INITIAL, open: true })) }
                >Добавить товар</div>
            }
            {
                !page && groups_page
                &&
                <div className="button button--add"
                     onClick={ () => dispatch(groupFormAction({ ...GROUP_FORM_INITIAL, open: true })) }
                >Добавить группу</div>
            }
            {
                page &&
                <div className="goods__download"
                    onClick={ () => dispatch(exportGoodsRestToExcelSagaAction()) }
                />
            }
        </>
    );
};

export default GoodsHeader;